module.exports = __webpack_public_path__ + "static/media/trainx4_lbr.131ef64b.mp4";